export default __webpack_public_path__ + "static/media/boots_of_the_vanguard.a7b48e03.jpg";